export default __webpack_public_path__ + "static/media/environment.8467743f.svg";